import React from 'react';
import { Paper, LinearProgress } from '@mui/material';
import Loaders from '../..';

export function Loading() {
  return (
    <Paper style={{ padding: 16 }}>
      <LinearProgress />
      <LinearProgress />
    </Paper>
  );
}

export const getListItemByType = (type, DefaultComponent) => {
  if (Loaders[type] && Loaders[type].views.listItem) {
    return Loaders[type].views.listItem();
  }
  return DefaultComponent || Loaders.Thing.views.listItem();
};

const loadView = (type, DefaultComponent) => getListItemByType(type, DefaultComponent);
export default loadView;
